<template>
  <div class="attributes">
    <p class="attributes__title">Servizi e regolamenti</p>

    <div class="attributes__content">
      <knowbefore-item
        v-for="attribute in attributes"
        :key="_uid+attribute.key"
        :icon="attribute.icon"
        :title="attribute.name"
      >
        <ul class="attributes__list">
          <li
            class="attributes__item"
            v-for="(data, data_index) in attribute.data"
            v-html="data"
            :key="_uid+data_index"
          />
        </ul>
      </knowbefore-item>
    </div>
  </div>
</template>

<script>
import { build_data_items } from '@liveeps/utilities'
import KnowBeforeItem from '@liveeps/components/blocks/knowbefore/knowbefore-item'

export default {
  inheritAttrs: false,
  name: 'attributes',

  props: {
    property: Object,
  },

  components: {
    'knowbefore-item': KnowBeforeItem,
  },

  data() {
    return {
    }
  },

  computed: {

    // Struttura dati: key, icon, name e content
    attributes() {
      const map = [
        { key: 'general', icon: 'exclamation', name: 'Informazioni generali' },
        { key: 'pets', icon: 'pets', name: 'Animali' },
      ]
      return build_data_items(map, this.property)
    }

  },

  created() {
  },

  mounted() {
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>

  .attributes {
    @extend %section;
    @extend %section_margin;

    &__title {
      display: flex;
      align-items: center;
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      line-height: normal;
    }

    &__content {
      @extend %section__content;
      padding-top: 0;
      padding-bottom: 0;
    }
  }

</style>